import { render, staticRenderFns } from "./LmProcessPases.vue?vue&type=template&id=505b59ee&"
import script from "./LmProcessPases.vue?vue&type=script&lang=js&"
export * from "./LmProcessPases.vue?vue&type=script&lang=js&"
import style0 from "./LmProcessPases.vue?vue&type=style&index=0&id=505b59ee&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports